import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import AccountBlock from 'components/AccountBlock/AccountBlock'
import Spinner from 'components/ui/Spinner/Spinner'
import { paymentApi } from 'api'
import { getCurrentLanguage, t } from '../translation'
import { addDays, isAfter, format } from 'date-fns'

class MyAccount extends Component {
  state = {
    user: '',
    paymentData: {},
    subscriptionCancelStatus: false,
    isLoading: true,
    loadingButton: false,
    isTrialWithoutCreditCard: false,
    currentLanguage: getCurrentLanguage(),
  }

  componentDidMount() {
    const freeDaysRemaining = isAfter(
      addDays(this.props.userCreatedDate, this.props.freeDays),
      new Date()
    )
    const isTrialWithoutCreditCard =
      freeDaysRemaining && this.props.trialWithoutCreditCard

    document.documentElement.classList.add('no_scale_mod')
    this.setState({ scaleClassIsSet: true })
    ;(this.props.subscribed && !isTrialWithoutCreditCard) ||
    (!this.props.isPro && !isTrialWithoutCreditCard)
      ? paymentApi
          .getPaymentList()
          .then((res) => this.setState({ paymentData: res.result, isLoading: false }))
      : this.setState({ isLoading: false })
    ;(this.props.subscribed && !isTrialWithoutCreditCard) ||
    (!this.props.isPro && !isTrialWithoutCreditCard)
      ? paymentApi
          .getCancelStatus()
          .then((res) => this.setState({ subscriptionCancelStatus: res.result.canceled }))
      : this.setState({ isLoading: false })

    this.setState({ isTrialWithoutCreditCard })
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('no_scale_mod')
  }

  cancelSubscription = () => {
    this.setState({ loadingButton: true })
    paymentApi
      .cancelSubscription()
      .then((res) =>
        this.setState({ subscriptionCancelStatus: true, loadingButton: false })
      )
  }

  reactivateSubscription = () => {
    this.setState({ loadingButton: true })
    paymentApi
      .reactivateSubscription()
      .then((res) =>
        this.setState({ subscriptionCancelStatus: false, loadingButton: false })
      )
  }

  render() {
    const formArray = [
      {
        type: 'text',
        id: 'account_1',
      },
    ]

    const payList = this.state?.paymentData?.charges || ''

    const cardInfo = {
      name: `${this.state.paymentData?.paymentMethod?.cardholderName || ''}`,
      card: `**** **** **** ${this.state.paymentData?.paymentMethod?.last4 || '****'}`,

      title: t('settings.CHANGE_CARD'),
      link: t('links.CHANGE_Card'),
    }

    return (
      <div className="modal_content modal_open">
        <div className="popup acc_mod save_files_mod">
          <div className="popup_in offset_mod" style={{ height: '100vh' }}>
            <Link
              to="/song-select"
              className="close_btn right_pos_mod account_mod"
            ></Link>
            <h2 className="section_title v5_mod offset_mod">
              {t('settings.VIEW_ACCOUNT')}
            </h2>
            {this.state.isLoading ? (
              <Spinner style={{ paddingTop: '25%' }} />
            ) : (
              <>
                <AccountBlock
                  title={this.props.userName || ''}
                  formEl={formArray}
                  formButton={t('auth.RESET_PASSWORD')}
                />
                <AccountBlock
                  title={
                    `${t('settings.JOIN_DATE')} ${
                      this.state.currentLanguage === 'en'
                        ? new Date(this.props.userCreatedDate).toDateString()
                        : format(new Date(this.props.userCreatedDate), 'dd/MM/yy')
                    }` || ' '
                  }
                  link="/contact"
                  formButton={t('settings.ACCOUNT')}
                />
                {((this.props.isDoctor && this.props.subscribed) ||
                  (!this.props.isPro && !this.state.isTrialWithoutCreditCard)) &&
                  (this.state.subscriptionCancelStatus ? (
                    <AccountBlock
                      title={t('settings.REACTIVATE_SUBSCRIPTION_TITLE')}
                      formButton={t('settings.REACTIVATE_SUBSCRIPTION')}
                      reactiveSubscription={
                        this.state.subscriptionCancelStatus ? true : false
                      }
                      loadingButton={this.state.loadingButton}
                      subscriptionHandler={this.reactivateSubscription}
                    />
                  ) : (
                    <AccountBlock
                      title={t('settings.CANCEL_SUBSCRIPTION_TITLE')}
                      formButton={t('settings.CANCEL_SUBSCRIPTION')}
                      cancelSubscription={
                        !this.state.subscriptionCancelStatus ? true : false
                      }
                      loadingButton={this.state.loadingButton}
                      subscriptionHandler={this.cancelSubscription}
                    />
                  ))}
                {((this.props.isDoctor && this.props.subscribed) ||
                  (!this.props.isPro && !this.state.isTrialWithoutCreditCard)) && (
                  <AccountBlock title={t('settings.CHANGE_CARD')} card={cardInfo} />
                )}
                {!!payList.length && (
                  <AccountBlock title={t('settings.PAYMENT_HISTORY')} payList={payList} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth: { error, attributes, isDoctor, isPro } }) => ({
  authError: error,
  userCreatedDate: attributes.userCreatedDate,
  subscribed: JSON.parse(attributes?.subscribed || false),
  attributes,
  userName: attributes.name,
  trialWithoutCreditCard: JSON.parse(
    attributes.permissions?.features?.trialWithoutCreditCard || false
  ),
  freeDays: attributes.licenses?.freeDays,
  userCreatedDate: new Date(attributes.userCreatedDate),
  isDoctor,
  isPro,
})

export default connect(mapStateToProps)(MyAccount)
